import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class UsersViewedMessageBlock extends Component {
  render() {
    const { message, lastViewedMessagesByUsers } = this.props;
    if (lastViewedMessagesByUsers[message.id]) {
      return (
        <div className={'lastViewedMessages'}>
          {this.props.lastViewedMessagesByUsers[message.id].map(item => {
            if (
              ![this.props.auntUserId, message.senderId].includes(item.user_id)
            ) {
              return (
                <span className="media-info-desc">
                  <img
                    className="media-object avatar"
                    src={item.avatar}
                    alt={`Пользователь ${item.username} просмотрел сообщение`}
                    title={`Пользователь ${item.username} просмотрел сообщение`}
                    width="17px"
                  />
                </span>
              );
            }
            return null;
          })}
        </div>
      );
    }
    return null;
  }
}

UsersViewedMessageBlock.propTypes = {
  auntUserId: PropTypes.number.isRequired,
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    senderId: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired
  }).isRequired,
  lastViewedMessagesByUsers: PropTypes.shape().isRequired
};

export default UsersViewedMessageBlock;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/_messages/UsersViewedMessageBlock.js